class utils {
  static getDescMese = (num_mese) => {
      switch(parseInt(num_mese)){
          case 1: return 'Gennaio';
          case 2: return 'Febbraio';
          case 3: return 'Marzo';
          case 4: return 'Aprile';
          case 5: return 'Maggio';
          case 6: return 'Giugno';
          case 7: return 'Luglio';
          case 8: return 'Agosto';
          case 9: return 'Settembre';
          case 10: return 'Ottobre';
          case 11: return 'Novembre';
          case 12: return 'Dicembre';
          default: return null;
      }
  }
  static validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }
  static apriPdfDaInputStream = (is) => {
    //Create a Blob from the PDF Stream
    const file = new Blob(
      [is], 
      {type: 'application/pdf'});
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    //Open the URL on new Window
    window.open(fileURL);           
  }
}

export default utils; 